import React from "react";

import Source from "./Source";

import { SourcesWrapper, Title } from "./style";

const Sources = ({ title, sources }) => (
  <SourcesWrapper>
    <Title variant="heading6">{title}</Title>
    {sources?.map((source, index) => (
      <Source {...source} index={index} key={index} />
    ))}
  </SourcesWrapper>
);

export default Sources;
